import { cx } from '@mage-ui/styled-system/css';
import { imageGallery } from '@mage-ui/styled-system/recipes';

export const ImageGallery = ({ src, alt, sizes, onError, className }) => {
	if (!src) {
		return null;
	}

	return (
		<img
			src={src}
			alt={alt ?? ''}
			width={sizes?.width || 280}
			height={sizes?.height || 280}
			className={cx(imageGallery(), className)}
			onError={onError}
		/>
	);
};
